export default {
  title_one: '🥳 {{offer}} zastosowano',
  title_few: '🥳 Zastosowano {{count}} oferty',
  title_many: '🥳 Zastosowano {{count}} ofert',
  title_other: '🥳 Zastosowano {{count}} oferty',
};
